module.exports = __webpack_public_path__ + "static/media/vivo1.33ad289c.jpeg";